export default __webpack_public_path__ + "a25767c84673fa23ed6e2704ec96c001.svg";